import { createApp, h } from 'vue';
import I18nVuePlugin from '~/i18n/vue_plugin';

import CompanyInputs from './components/inputs.vue';
import { objectPropsToCamelCase } from '~/lib/utils/api';

export function setupSignUpCompanyInputs() {
  const el = document.querySelector('.js-sign-up-company-input');

  if (!el) return null;

  const inputsData = objectPropsToCamelCase(JSON.parse(el.dataset.inputsData));
  const countrySelectOptions = objectPropsToCamelCase(JSON.parse(el.dataset.countrySelectOptions));
  const form = objectPropsToCamelCase(JSON.parse(el.dataset.form));

  const app = createApp(
    {
      render: () => h(CompanyInputs)
    },
    {
      inputsData,
      countrySelectOptions,
      form
    }
  );

  app.use(I18nVuePlugin);
  app.mount(el);
}
